import 'slick-carousel/slick/slick';
import utils from './lsag.utils';

const productCarousel = {
    productCarousels: $('.js-carousel'),
    bindDyTracking() {
        $('.js-dy-carousel').on('click', event => {
            //prevent double click tracking on this page
            $('.js-dy-carousel').off('click');

            //do not jump to the PDP yet
            event.preventDefault();

            const redirectTo = event.target.closest('a').href
            var jsCarousel = event.target.closest('.js-dy-carousel');
            var jsCarouselItem = event.target.closest('.js-dy-carousel-item');

            $.ajax({
                url: window.location.origin + ACC.config.encodedContextPath + '/view/ProductCarouselComponentController/trackDYInteraction',
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({
                    variationId: jsCarousel.dataset.variationId,
                    decisionId: jsCarousel.dataset.decisionId,
                    slotId: jsCarouselItem.dataset.slotId,
                    serverId: utils.getCookie("_dyid_server"),
                    dyId: utils.getCookie("_dyid"),
                    sessionId: utils.getCookie("_dyjsession")
                })
            }).done(function (data) {
                console.debug("DY Interaction tracked: " + data);
            }).fail(function (jqXHR) {
                console.debug("Could not send DY tracking data: Error " + jqXHR.status);
            }).always(function () {
                window.location.href = redirectTo;
            });

        });
    },
    buildCarousel($carousel) {
        if (!$carousel.length) {
            return;
        }

        // SlickSlider can't handle only one item also return
        if ($carousel.find('.c-carousel__item').length === 1) {
            return;
        }
        $carousel
            .removeClass('c-carousel--not-ready')
            .on('init', function (event, slick) {
                // some hack to fix the behaviour for carousels with few elements
                if (slick.slideCount < 4) {
                    console.warn('Few products in the product carousel detected');
                    slick.originalSettings.slidesToScroll = slick.slideCount;
                    slick.originalSettings.slidesToShow = slick.slideCount;
                    slick.originalSettings.responsive[0].settings.slidesToScroll = slick.slideCount;
                    slick.originalSettings.responsive[0].settings.slidesToShow = slick.slideCount;
                }
            })
            .slick({
                arrows: true,
                prevArrow: `
                    <button class="c-carousel--prev slick-arrow btn-reset">
                        <svg class="icon icon-scroll-left-no-bg">
                            <use xlink:href="#icon-scroll-left-no-bg"></use>
                        </svg>
                    </button>
                `,
                nextArrow: `
                    <button class="c-carousel--next slick-arrow btn-reset">
                        <svg class="icon icon-scroll-right-no-bg">
                            <use xlink:href="#icon-scroll-right-no-bg"></use>
                        </svg>
                    </button>
                `,
                infinite: true,
                slidesToScroll: 4,
                slidesToShow: 4,
                speed: 300,
                dots: true,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToScroll: 2,
                            slidesToShow: 2
                        }
                    }
                ]
            });
    },
    buildCarousels() {
        this.productCarousels.each((index, element) => {
            const $element = $(element);
            if ($element.closest('#js-intersections').length) {
                utils.logger.log('Product Carousel as intersection detected');
                return;
            }
            this.buildCarousel($element);
        });
    },
    populateShowMoreButton($target, data) {
        if (!$target.length) {
            return;
        }
        const showMoreTitle = data.showmoretitle;
        const showMoreUrl = data.showmoreurl;
        const showMorePDP = data.showmorepdp;
        const showMorePDPUrl = $('.js-pdp-category-urls').data(`category-${showMorePDP}`);

        if (showMoreUrl !== '' || (showMorePDP !== '' && showMorePDPUrl !== undefined)) {
            if (showMoreTitle) {
                $target.attr('title', showMoreTitle);
            }
            $target.attr('href', showMoreUrl !== '' ? showMoreUrl : showMorePDPUrl);
            $target.removeClass('d-none');
        }
    }
};

// DOM ready
$(() => {
    const dyCarousels = $('.js-placeholder-dy-carousel');
    if (dyCarousels.length) {
        dyCarousels.each(function (index, element) {
            const dyCarousel = $(element);
            if (dyCarousel.closest('#js-intersections').length) {
                utils.logger.log('DY Carousel as intersection detected');
                return;
            }
            $.ajax({
                url: window.location.origin + ACC.config.encodedContextPath + '/view/ProductCarouselComponentController/' + dyCarousel.data('id'),
                type: 'GET'
            }).done(function (response) {
                const $wishlist = dyCarousel.closest('.js-wishlist-controller');
                const wishlistController = $wishlist.length && window.angular ? $wishlist.scope().wishlist : undefined;
                const $html = $(response);

                productCarousel.populateShowMoreButton($html.find('.js-productcarousel-showmorebutton'), element.dataset)

                if (wishlistController) {
                    dyCarousel.replaceWith(wishlistController.$compile($html)(wishlistController.$scope));
                } else {
                    dyCarousel.replaceWith($html);
                    console.info('SmartEdit active or Wishlist feature disabled');
                }

                // TODO: In case of problems, it is better to use the wishlist as in Algolia code
                setTimeout(function () {
                    if (wishlistController) {
                        wishlistController.$rootScope.$digest();
                    }
                    productCarousel.buildCarousel($html.find('.js-carousel-lazy'));
                    productCarousel.bindDyTracking();
                    if (wishlistController) {
                        wishlistController.$rootScope.$broadcast('loadAlgoliaProductsSuccess');
                    }
                }, 1)
            }).fail(function (error) {
                console.debug("Cannot load " + dyCarousel.data('id'));
            });
        })
    }
    productCarousel.buildCarousels();
    $('.js-productcarousel-showmorebutton').each((index, element) => {
        const $element = $(element);
        const dataset = element.closest('.c-carousel__wrapper').dataset;
        productCarousel.populateShowMoreButton($element, dataset)
    });
});

export default productCarousel;
